export default __webpack_public_path__ + "static/media/Teia_Jones_AHV_In_Moms_We_Trust.f006d5bf.jpg";